'use client';

import React from 'react';
import notebookImg from '../../../public/images/notebook.png';
import modelImg from '../../../public/images/model.png';
import inferenceImg from '../../../public/images/inference.png';
import solutionstorageImg from '../../../public/images/solutionstorage.png';
import solutionobservabilityImg from '../../../public/images/solutionobservability.png';
import { useGlobalClientContext } from '../common/GlobalClientContext';

export default function Solutions() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <div className="flex flex-col w-[1280px] bg-gray-50">
      <div className="h-fit flex flex-row items-center justify-between">
        <div className="flex flex-col items-start pl-10xl w-[556px]">
          <div className="text-4xl font-gray-900 font-semibold leading-18xl">
            {t('public.site.solution.notebook.title', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-gray-600 mt-3xl">
            {t('public.site.solution.notebook.description', {})}
            <br />
            {t('public.site.solution.notebook.description1', {})}
          </div>
        </div>
        <div>
          <img className="w-[660px] h-[456px]" src={notebookImg.src} alt="" />
        </div>
      </div>
      <div className="h-fit flex flex-row items-center justify-between mt-9xl">
        <div>
          <img className="w-[660px] h-[456px]" src={modelImg.src} alt="" />
        </div>
        <div className="flex flex-col items-start pr-10xl w-[556px]">
          <div className="text-4xl font-gray-900 font-semibold leading-18xl">
            {t('public.site.solution.model.title', {})}
            <br />
            {t('public.site.solution.model.title1', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-gray-600 mt-3xl">
            {t('public.site.solution.model.description', {})}
            <br />
            {t('public.site.solution.model.description1', {})}
          </div>
        </div>
      </div>
      <div className="h-fit flex flex-row items-center justify-between mt-9xl">
        <div className="flex flex-col items-start pl-10xl w-[556px]">
          <div className="text-4xl font-gray-900 font-semibold leading-18xl">
            {t('public.site.solution.inference.title', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-gray-600 mt-3xl">
            {t('public.site.solution.inference.description', {})}
            <br />
            {t('public.site.solution.inference.description1', {})}
          </div>
        </div>
        <div>
          <img className="w-[660px] h-[456px]" src={inferenceImg.src} alt="" />
        </div>
      </div>
      <div className="h-fit flex flex-row items-center justify-between mt-9xl">
        <div>
          <img className="w-[660px] h-[456px]" src={solutionstorageImg.src} alt="" />
        </div>
        <div className="flex flex-col items-start pr-10xl w-[556px]">
          <div className="text-4xl font-gray-900 font-semibold leading-18xl">
            {t('public.site.solution.storage.title', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-gray-600 mt-3xl">
            {t('public.site.solution.storage.description', {})}
          </div>
        </div>
      </div>
      <div className="h-fit flex flex-row items-center justify-between mt-9xl">
        <div className="flex flex-col items-start pl-10xl w-[556px]">
          <div className="text-4xl font-gray-900 font-semibold leading-18xl">
            {t('public.site.solution.observability.title', {})}
          </div>
          <div className="text-xl font-regular leading-3xl text-gray-600 mt-3xl">
            {t('public.site.solution.observability.description', {})}
            <br />
            {t('public.site.solution.observability.description1', {})}
          </div>
        </div>
        <div>
          <img className="w-[660px] h-[456px]" src={solutionobservabilityImg.src} alt="" />
        </div>
      </div>
    </div>
  );
}